query tipoFluxoSelect($where: EnumItemDTOFilterInput) {
    data: tiposFluxos(where: $where)  {
        label
        value
    }
}